import UPLOAD_STATUS from './upload-status'

	function File(fileInfo, settings) {
		fileInfo = fileInfo || {};

		this.url = fileInfo.url || "";
		this.name = fileInfo.name || "";
		this.size = fileInfo.size || 0;
		this.type = fileInfo.type || "";
		this.lastModifiedDate = fileInfo.lastModifiedDate || new Date();
		this.fuid = fileInfo.fuid || "";
		// TODO
		this.fcks = Math.ceil(fileInfo.size / settings.chunkSize);
		this.fseq = 0;

		// customize
		this.errorTimes = 0;
		this.uploadStatus = UPLOAD_STATUS.INIT;
	}

	export default File;